import { jsxs, jsx } from "react/jsx-runtime";
import { Text } from "@wix/wix-ui-tpa/cssVars";
import * as React from "react";
import { st, classes } from "./CoreDropdownContent.st.css";
import { CoreDropdownOption } from "../CoreDropdownOption/CoreDropdownOption.js";
const NOT_HOVERED_INDEX = -1;
class CoreDropdownContent extends React.PureComponent {
  static displayName = "CoreDropdownContent";
  optionsContainerRef = null;
  mouseCoords = { screenX: -1, screenY: -1 };
  constructor(props) {
    super(props);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onOptionHover = this.onOptionHover.bind(this);
  }
  state = { hoveredIndex: NOT_HOVERED_INDEX };
  scrollToSelectedOption() {
    const { options, selectedIds } = this.props;
    if (!selectedIds.length || !this.optionsContainerRef) {
      return;
    }
    const selectedIndex = options.findIndex(
      (option) => option.id === selectedIds[0]
    );
    if (selectedIndex === -1) {
      return;
    }
    requestAnimationFrame(() => {
      if (!this.optionsContainerRef) {
        return;
      }
      const selectedOption = this.optionsContainerRef.childNodes[selectedIndex];
      if (!selectedOption) {
        return;
      }
      const parentRect = this.optionsContainerRef.getBoundingClientRect();
      const selectedRect = selectedOption.getBoundingClientRect();
      if (selectedRect.bottom > parentRect.bottom) {
        this.optionsContainerRef.scrollTop = Math.min(
          selectedOption.offsetTop + selectedOption.clientHeight / 2 - this.optionsContainerRef.offsetHeight / 2,
          this.optionsContainerRef.scrollHeight
        );
      }
      this.setHoveredIndex(selectedIndex);
    });
  }
  componentDidMount() {
    const { focusOnOption } = this.props;
    this.scrollToSelectedOption();
    if (!this.props.selectedIds.length && focusOnOption) {
      this.hoverItemById(focusOnOption);
    }
  }
  componentDidUpdate(prevProps) {
    const { focusOnOption, selectedIds } = this.props;
    if (selectedIds.length && (!prevProps.selectedIds.length || selectedIds[0] !== prevProps.selectedIds[0])) {
      this.scrollToSelectedOption();
    }
    if (focusOnOption !== prevProps.focusOnOption) {
      this.hoverItemById(focusOnOption);
    }
  }
  setHoveredIndex(index) {
    this.setState(
      {
        hoveredIndex: index
      },
      this.onOptionHover
    );
  }
  onOptionHover() {
    if (this.props.onOptionHover) {
      this.props.onOptionHover(this.getSelectedOption());
    }
  }
  isValidOptionForSelection(option) {
    return option.isSelectable && !option.isDisabled;
  }
  hoverNextItem(interval) {
    const { options } = this.props;
    if (!options.find(this.isValidOptionForSelection)) {
      return;
    }
    let { hoveredIndex } = this.state;
    while (true) {
      hoveredIndex += interval;
      if (hoveredIndex === options.length) {
        hoveredIndex = 0;
      } else if (hoveredIndex < 0) {
        hoveredIndex = options.length - 1;
      }
      if (this.isValidOptionForSelection(options[hoveredIndex])) {
        break;
      }
    }
    this.hoverItemAtIndex(hoveredIndex);
  }
  hoverItemById(id) {
    const { options } = this.props;
    const index = options.findIndex((option) => option.id === id);
    if (index !== -1) {
      this.hoverItemAtIndex(index);
    }
  }
  hoverItemAtIndex(index) {
    const { options } = this.props;
    if (!options.find(this.isValidOptionForSelection)) {
      return;
    }
    if (this.optionsContainerRef) {
      const hoveredOption = this.optionsContainerRef.childNodes[index];
      const hoveredOptionHeight = hoveredOption.offsetHeight;
      const hoveredOptionTop = hoveredOption.offsetTop - 1;
      const {
        scrollTop: optionsContainerScrollTop,
        clientHeight: optionsContainerClientHeight
      } = this.optionsContainerRef;
      if (!(optionsContainerScrollTop <= hoveredOptionTop && optionsContainerScrollTop + optionsContainerClientHeight > hoveredOptionTop + hoveredOptionHeight)) {
        if (this.optionsContainerRef.scrollTop < hoveredOptionTop) {
          this.optionsContainerRef.scrollTop = hoveredOptionHeight + hoveredOptionTop - optionsContainerClientHeight;
        } else {
          this.optionsContainerRef.scrollTop = hoveredOptionTop;
        }
      }
    }
    this.setHoveredIndex(index);
  }
  getOptionDOMid(option) {
    const optionsContainerId = this.props.optionsContainerId;
    return optionsContainerId ? `${optionsContainerId}_option-${option.id}` : null;
  }
  getSelectedOption() {
    const { options } = this.props;
    const { hoveredIndex } = this.state;
    const isValidIndex = hoveredIndex >= 0 && hoveredIndex < options.length;
    return isValidIndex ? {
      ...options[hoveredIndex],
      _DOMid: this.getOptionDOMid(options[hoveredIndex])
    } : null;
  }
  onKeyDown(eventKey, evt) {
    switch (eventKey) {
      case "ArrowUp": {
        evt.preventDefault();
        return this.hoverNextItem(-1);
      }
      case "ArrowDown": {
        evt.preventDefault();
        return this.hoverNextItem(1);
      }
      case "ArrowLeft":
      case "ArrowRight": {
        return;
      }
    }
  }
  onMouseMove(evt) {
    this.mouseCoords.screenX = evt.screenX;
    this.mouseCoords.screenY = evt.screenY;
  }
  onMouseDown(e) {
    const { onMouseDown } = this.props;
    onMouseDown && onMouseDown(e);
  }
  onMouseEnter(evt, index) {
    if (this.mouseCoords.screenX !== evt.screenX || this.mouseCoords.screenY !== evt.screenY) {
      this.setHoveredIndex(index);
    }
  }
  render() {
    const {
      fixedHeader,
      fixedFooter,
      options,
      selectedIds,
      onOptionClick,
      optionsContainerId,
      className,
      role = "menu",
      noResultsText
    } = this.props;
    const { hoveredIndex } = this.state;
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: st(classes.root, className),
        "data-hook": this.props["data-hook"],
        onMouseMove: this.onMouseMove,
        onMouseDown: this.onMouseDown,
        children: [
          fixedHeader,
          /* @__PURE__ */ jsxs(
            "div",
            {
              role,
              className: classes.optionsContainer,
              id: optionsContainerId,
              ref: (optionsContainer) => this.optionsContainerRef = optionsContainer,
              children: [
                !options?.length && !!noResultsText && /* @__PURE__ */ jsx(
                  Text,
                  {
                    role: "alert",
                    priority: "secondary",
                    className: classes.noResultsText,
                    children: noResultsText
                  }
                ),
                (options || []).map((option, index) => /* @__PURE__ */ jsx(
                  CoreDropdownOption,
                  {
                    className: classes.dropdownOption,
                    dataHook: "option",
                    id: this.getOptionDOMid(option),
                    option,
                    isHovered: hoveredIndex === index,
                    isSelected: (selectedIds || []).includes(option.id),
                    role: role === "listbox" ? "option" : "menuitem",
                    onClickHandler: this.isValidOptionForSelection(option) ? () => onOptionClick(option) : void 0,
                    onMouseEnterHandler: this.isValidOptionForSelection(option) ? (evt) => this.onMouseEnter(evt, index) : void 0,
                    onMouseLeaveHandler: () => {
                      this.setHoveredIndex(NOT_HOVERED_INDEX);
                    }
                  },
                  option.id
                ))
              ]
            }
          ),
          fixedFooter
        ]
      }
    );
  }
}
export {
  CoreDropdownContent
};
//# sourceMappingURL=CoreDropdownContent.js.map
